// Brand colors
export const B = {
  forest: '#2D4F3F',
  olive: '#6B7F5E',
  rust: '#A85D4A',
  sand: '#D4C8B8',
  cream: '#F5F1EB',
  stone: '#8B8178',
  sage: '#9CAF88',
  copper: '#B87333',
};

// Level styles for hierarchy display
export const levelStyles = {
  0: { bg: B.forest, text: '#fff', indent: 0 },
  1: { bg: B.olive, text: '#fff', indent: 1 },
  2: { bg: B.sage, text: B.forest, indent: 2 },
  3: { bg: B.sand, text: B.forest, indent: 3 },
  4: { bg: B.cream, text: B.forest, indent: 4 },
};

// Ownership options for police reports
export const ownershipOptions = [
  'Supply Chain',
  'Merchandising',
  'Planning',
  'Vendor',
  'DC/Logistics',
  'Finance',
  'Other'
];

// Standard category values (matching database division column)
export const CATEGORIES = ['Footwear', 'Apparel', 'Accessories'];

// Channel display names
export const channelDisplayNames = {
  'RETAIL': 'Retail',
  'WHOLESALE': 'Wholesale',
  'ECOMM': 'Ecomm',
  'FG - RETAIL': 'Retail',
  'FG - WHOLESALE': 'Wholesale',
  'FG - ECOMM': 'Ecomm',
};

// Status colors for PO tracking
export const statusColors = {
  'On Time': B.olive,
  'Late': B.rust,
  'Received On-Time': B.olive,
  'Received Late': B.sand,
  'Pending': B.stone,
};

// Inventory location configuration
// Type: 'dc' for fulfillment centers, 'store' for retail, 'exclude' to omit from counts
export const LOCATION_CONFIG = {
  // Fulfillment / DC locations
  'FG - Ecomm': { type: 'dc', label: 'Ecomm' },
  'FG - Retail': { type: 'dc', label: 'Retail' },
  'FG - Wholesale': { type: 'dc', label: 'Wholesale' },
  'FG - Marketing': { type: 'dc', label: 'Marketing' },

  // On Hold
  'Geodis Dallas': { type: 'onhold', label: 'On Hold' },
  'Geodis Dallas - On Hold': { type: 'onhold', label: 'On Hold' },

  // Excluded locations
  'Geodis Dallas - B Grade': { type: 'exclude' },
  'Geodis Dallas - C Grade': { type: 'exclude' },
  'Geodis Dallas - D Grade': { type: 'exclude' },
  'HQ': { type: 'exclude' },
};

// Helper to get location type (defaults to 'store' for numbered stores, excludes Damages)
export const getLocationType = (location) => {
  if (!location) return 'exclude';

  // Check explicit config first
  if (LOCATION_CONFIG[location]) {
    return LOCATION_CONFIG[location].type;
  }

  // Exclude Damages locations
  if (location.startsWith('Damages')) {
    return 'exclude';
  }

  // Numbered stores (001 - XXX) are retail stores
  if (/^\d{3}\s*-/.test(location)) {
    return 'store';
  }

  // Default to exclude for unknown
  return 'exclude';
};
